<!-- New Preloader -->
<div class="no-freeze-spinner">
    <div id="no-freeze-spinner">
    </div>
</div>